import { jsx as o, jsxs as c } from "@emotion/react/jsx-runtime";
import { useCallback as ne, useMemo as re, useEffect as te } from "react";
import { useDropzone as ie } from "react-dropzone";
import { useDimension as ce } from "../../hooks/useDimension.js";
import { DocumentThumbs as me } from "./DocumentThumbs/DocumentThumbs.js";
import { DropzoneGridContainer as ae, FullSreenImage as se, StyledDropzoneContainer as he } from "./Dropzone.styled.js";
import { iconBuilder as de } from "./helpers.js";
import { Loader as ue } from "../Loader/index.js";
import { Stack as a } from "../Stack/index.js";
import { Text as u } from "../Text/index.js";
import { InnerPreview as pe } from "./InnerPreview/InnerPreview.js";
import { OuterPreview as ge } from "./OuterPreview/OuterPreview.js";
import { RejectedDocumentThumbs as le } from "./RejectedDocumentThumbs/RejectedDocumentThumbs.js";
import { Thumbs as ve } from "./Thumbs/Thumbs.js";
import { DropzoneTypeEnum as r } from "../../types/components/dropzone.js";
const fe = (e) => /* @__PURE__ */ o(he, { ...e, children: e.children }), ke = ({
  files: e,
  onDropSuccess: p,
  onDelete: s,
  customValidator: S,
  title: g,
  accept: L,
  acceptedDescription: l,
  errorTitle: z,
  full: t = !0,
  numberPerLine: C = 0,
  // equivalent to full
  dragText: v,
  type: n = r.Photo,
  multiple: i = !0,
  maxFiles: I = 0,
  // react-dropzone default value - equal to no limitations
  minSize: x = 0,
  maxSize: F = 1 / 0,
  disabled: f = !1,
  loading: D = !1,
  noDrag: U = !1,
  actionThumb: O,
  // for now, only available for full photo but you can extend it to other use cases.
  className: k,
  cssContainer: M,
  children: T,
  displayPreview: j = !0,
  errorTranslations: E,
  customPreview: A,
  persistFiles: w = !1
}) => {
  const [B, P] = ce(), G = ne((m) => {
    const R = m.map((b) => Object.assign(b, {
      preview: URL.createObjectURL(b)
    }));
    p(w ? [...e, ...R] : R);
  }, [e, p, w]), q = () => {
    s(e[0]?.name);
  }, H = re(() => D ? /* @__PURE__ */ o(ue, { variant: "spinner", size: "medium" }) : de[n].default, [D, n]), {
    fileRejections: h,
    getRootProps: J,
    getInputProps: K,
    isDragActive: N,
    isFocused: Q,
    isDragAccept: V,
    isDragReject: W
  } = ie({
    accept: L,
    onDrop: G,
    disabled: f,
    noDrag: U,
    maxFiles: I,
    maxSize: F,
    minSize: x,
    multiple: i,
    validator: S
  }), X = n === r.Document && !i && e.length === 1, d = n === r.Photo && !i && e.length === 1, Y = d && t, Z = n === r.Document && !t && i, _ = n === r.Photo && !t && i, $ = e.length >= 1 && n === r.Photo && /* @__PURE__ */ o(ve, { files: e, removeFile: s, width: P?.width }), y = /* @__PURE__ */ o(a, { gap: "8px", children: /* @__PURE__ */ o(me, { files: e, removeFile: s }) }), ee = h.length >= 1 && /* @__PURE__ */ o(le, { files: h, type: n, errorTitle: z, errorTranslations: E });
  te(() => () => e.forEach((m) => {
    m.preview && URL.revokeObjectURL(m.preview);
  }), [e]);
  const oe = n === r.Document ? y : $;
  return /* @__PURE__ */ c(a, { gap: "24px", children: [
    h?.length > 0 && /* @__PURE__ */ o(ge, { children: ee }),
    /* @__PURE__ */ c(ae, { full: t, numberPerLine: C, type: n, isSmallMultiplePhoto: _, children: [
      !X && /* @__PURE__ */ c(fe, { ...J({
        className: k,
        "aria-disabled": f,
        isFocused: Q,
        isDragAccept: V,
        isDragReject: W,
        full: t,
        ref: B,
        cssContainer: M,
        isSmallMultipleDocument: Z,
        width: P?.width
      }), children: [
        /* @__PURE__ */ c(a, { alignItems: "center", justifyContent: "center", children: [
          /* @__PURE__ */ o("input", { ...K() }),
          H,
          /* @__PURE__ */ c(a, { gap: "4px", justifyContent: "center", alignItems: "center", children: [
            N && v ? /* @__PURE__ */ o(u, { variant: "heading6", as: "span", children: v }) : g && /* @__PURE__ */ o(u, { variant: "heading6", as: "span", children: g }),
            l && /* @__PURE__ */ o(u, { variant: "bodyMRegular", as: "span", color: "secondary", children: l }),
            T
          ] })
        ] }),
        d && j && /* @__PURE__ */ o(pe, { removeFile: q, actionThumb: O, isSingleFullPhoto: Y, children: /* @__PURE__ */ o(se, { imageSrc: e[0].preview, onLoad: () => {
          URL.revokeObjectURL(e[0].preview);
        } }) })
      ] }),
      j && !d && (oe || A)
    ] })
  ] });
};
export {
  ke as Dropzone,
  fe as DropzoneContainer
};
